import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import Cookies from "js-cookie";

const SupportLogin = () => {
  const history = useHistory();
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const adminCredentials = {
    name: "admin",
    password: "test123456",
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError("");

    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/support/login",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ name, password }),
        }
      );

      if (!response.ok) {
        const message = await response.json();
        throw new Error(message?.message || "Unable to login");
      }

      const data = await response.json();
      const isAdminLogin =
        data?.is_admin ||
        (name === adminCredentials.name &&
          password === adminCredentials.password);

      Cookies.set("support_token", data.token);
      Cookies.set("support_employee_id", data.employee.id);
      Cookies.set("support_employee_name", data.employee.name);
      if (isAdminLogin) {
        Cookies.set("support_is_admin", "true");
      } else {
        Cookies.remove("support_is_admin");
      }
      history.push("/cs-dashboard");
    } catch (err) {
      setError(err.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f5f7fb",
      }}
    >
      <form
        onSubmit={handleSubmit}
        style={{
          width: "100%",
          maxWidth: "420px",
          background: "white",
          padding: "32px",
          borderRadius: "16px",
          boxShadow: "0 12px 30px rgba(0,0,0,0.08)",
          fontFamily: "Manrope, sans-serif",
          color: "#0e5aa5",
        }}
      >
        <h2 style={{ marginBottom: "16px", fontWeight: 800 }}>
          Customer Support Login
        </h2>
        <p style={{ marginBottom: "24px", color: "#6b7b93" }}>
          Sign in with your employee credentials to access the borrower
          workspace.
        </p>

        {error ? (
          <div
            style={{
              background: "#fff1f0",
              border: "1px solid #ffa39e",
              color: "#cf1322",
              padding: "10px 14px",
              borderRadius: "8px",
              marginBottom: "14px",
            }}
          >
            {error}
          </div>
        ) : null}

        <label style={{ fontWeight: 700 }}>Employee Name</label>
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Enter your name"
          style={{
            width: "100%",
            padding: "12px",
            borderRadius: "10px",
            border: "1px solid #d9d9d9",
            marginTop: "6px",
            marginBottom: "16px",
          }}
          required
        />

        <label style={{ fontWeight: 700 }}>Password</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Enter your password"
          style={{
            width: "100%",
            padding: "12px",
            borderRadius: "10px",
            border: "1px solid #d9d9d9",
            marginTop: "6px",
            marginBottom: "24px",
          }}
          required
        />

        <button
          type="submit"
          disabled={isSubmitting}
          style={{
            width: "100%",
            padding: "12px",
            background: "#0e5aa5",
            color: "white",
            fontWeight: 700,
            border: "none",
            borderRadius: "10px",
            cursor: "pointer",
          }}
        >
          {isSubmitting ? "Signing in..." : "Sign In"}
        </button>
      </form>
    </div>
  );
};

export default SupportLogin;
